import { render, staticRenderFns } from "./ExcessiveIdling.vue?vue&type=template&id=32bf5158&"
import script from "./ExcessiveIdling.vue?vue&type=script&lang=js&"
export * from "./ExcessiveIdling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports